import { Popup } from './Popup';

export function addPopupVModel(popup: Popup) {
	return {
		isOpen: popup.isOpen,
		'onUpdate:isOpen': (val: boolean) => (popup.isOpen = val),
	};
}
